// База облачного API (Cloudflare Worker). В dev — локальный wrangler dev,
// в проде — https://api.barter.pp.ua (задаётся при сборке через .env.production).

export const API_BASE: string = (import.meta.env.VITE_API_BASE as string | undefined) || '';

/**
 * Фото в объявлениях хранятся как относительные ключи ("photos/<adId>/0.webp").
 * Временно созданные объявления могут держать data:/blob: URL — их не трогаем.
 */
export function photoUrl(photo: string): string {
  if (/^(https?:|data:|blob:)/i.test(photo)) return photo;
  return `${API_BASE}/${photo.replace(/^\//, '')}`;
}
